import React, { useEffect, useState } from "react";
import Shearchbar from "./Shearchbar";
import Security from "./Security";
import Footer from "./Footer";
import Navbar from "./Navbar";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BsFillCloudUploadFill } from "react-icons/bs";
import Manubar from "./Manubar";
import "react-tabs/style/react-tabs.css";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  AvatarGroup,
  IconButton,
  Stack,
  Divider,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CardActions,
  CircularProgress,
} from "@mui/material";
import {
  Cancel,
  Person,
  Visibility,
  CalendarToday,
  Euro,
  ShoppingBag,
  ExitToApp,
  LocationOn,
  Receipt,
  Info,
  Add,
  Edit,
  Delete,
  Home,
  Article,
  PrivacyTip,
  Groups,
} from "@mui/icons-material";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Address = () => {
  let Navigate = useNavigate();

  const location = useLocation();
  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");
  let [get_user_profile, setget_user_profile] = useState([]);
  let [orderlist, setOrderList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("Pending");
  let [show_address, setshow_address] = useState([]);
  let [pincodemsg, setpincodemsg] = useState();
  const [activeTab, setActiveTab] = useState(location.state || "dashboard");
  const [dashboardData, setDashboardData] = useState([]);
  const [policy, setPolicy] = useState([]);
  const [terms_and_condition, setterms_and_condition] = useState([]);
  const [cancelDialog, setCancelDialog] = useState({
    open: false,
    orderId: null,
  });
  let [add_address, setadd_address] = useState({
    user_id: _id,
    landmark: "",
    address: "",
    city: "",
    pin_code: "",
  });
  const [about_us, setabout_us] = useState([]);
  let [newPinValue, setNewPinValue] = useState();
  let [oldPinvalue, setOldPinValue] = useState();
  const [showNewPin, setShowNewPin] = useState(false);
  const [showOldPin, setShowOldPin] = useState(false);

  // Add these new state variables at the top with your other states
  let [loading, setLoading] = useState(false);
  let [deleteLoading, setDeleteLoading] = useState(null);
  let [addLoading, setAddLoading] = useState(false);
  let [editLoading, setEditLoading] = useState(false);
  const [addressDialog, setAddressDialog] = useState({
    open: false,
    address: "",
  });
  const [transactionsData, setTransactionsData] = useState([]);
  let [editaddress, seteditaddress] = useState({
    address_id: "",
    user_id: _id,
    landmark: "",
    address: "",
    city: "",
    pin_code: "",
  });

  const getTransactionStatusColor = (status) => {
    switch (status) {
      case "completed":
        return "success";
      case "pending":
        return "warning";
      case "failed":
        return "error";
      default:
        return "default";
    }
  };

  const fetchAddress = async () => {
    try {
      setLoading(true);
      const items = { user_id: _id };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/get_address`,
        items,
        {
          headers: {
            token: token,
          },
        }
      );

      if (res.data?.result) {
        setshow_address(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching address:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddress();
  }, []);

  // Add address Handel
  let inpuHandel = (event) => {
    setadd_address({
      ...add_address,
      [event.target.name]: event.target.value,
      token: token,
    });
  };

  let FormHandel = async (e) => {
    e.preventDefault();

    if (add_address.pin_code.length !== 6) {
      setpincodemsg("Not Valid Pincode");
      toast.error("Please enter a valid 6-digit pincode");
      return;
    }

    try {
      setAddLoading(true);
      setpincodemsg("");

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_address`,
        add_address
      );

      if (res.data.result) {
        toast.success(res.data.msg);
        setadd_address({
          landmark: "",
          address: "",
          city: "",
          pin_code: "",
        });
        // Close modal and refresh addresses
        document.querySelector('[data-dismiss="modal"]')?.click();
        await fetchAddress();
      } else {
        toast.error(res.data.msg || "Failed to add address");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error adding address");
    } finally {
      setAddLoading(false);
    }
  };

  const AddressText = ({ text, maxLength = 50 }) => {
    const [expanded, setExpanded] = useState(false);

    if (!text) return null;

    if (text.length <= maxLength) {
      return <Typography variant="body2">{text}</Typography>;
    }

    return (
      <Box>
        <Typography variant="body2">
          {expanded ? text : `${text.substring(0, maxLength)}...`}
        </Typography>
        <Button
          size="small"
          onClick={() => {
            if (expanded) {
              setExpanded(false);
            } else {
              setAddressDialog({ open: true, address: text });
            }
          }}
          sx={{
            textTransform: "none",
            fontSize: "0.75rem",
            fontWeight: 600,
            color: "primary.main",
            minWidth: "auto",
            p: 0,
            mt: 0.5,
          }}
        >
          {expanded ? "Read Less" : "Read More"}
        </Button>
      </Box>
    );
  };

  let eidtaddreddss = (_id, landmark, address, city, pin_code) => {
    //console.log(_id)
    let address_id = _id;
    seteditaddress({
      ...editaddress,
      address_id,
      landmark,
      address,
      city,
      pin_code,
    });
  };
  let editinpuHandel = (e) => {
    seteditaddress({ ...editaddress, [e.target.name]: e.target.value });
  };
  let editFormHandel = async (e) => {
    e.preventDefault();

    try {
      setEditLoading(true);

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/update_address`,
        editaddress,
        {
          headers: {
            token: token,
          },
        }
      );

      if (res.data.result) {
        toast.success(res.data.msg);
        // Close modal and refresh addresses
        document.querySelector('[data-dismiss="modal"]')?.click();
        await fetchAddress();
      } else {
        toast.error(res.data.msg || "Failed to update address");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error updating address");
    } finally {
      setEditLoading(false);
    }
  };

  // Update the deleteaddress function
  let deleteaddress = async (deleteaddress_id) => {
    if (!window.confirm("Are you sure you want to delete this address?")) {
      return;
    }

    try {
      setDeleteLoading(deleteaddress_id);

      let data = {
        user_id: _id,
        address_id: deleteaddress_id,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/delete_address`,
        data,
        {
          headers: {
            token: token,
          },
        }
      );

      if (res.data.result) {
        toast.success(res.data.msg);
        await fetchAddress(); // Refresh the address list
      } else {
        toast.error(res.data.msg || "Failed to delete address");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error deleting address");
    } finally {
      setDeleteLoading(null);
    }
  };
  return (
    <div>
      <Box sx={{ p: 3 }}>
        {/* Header Section */}
        <Box
          sx={{
            mb: 4,
            pb: 3,
            borderBottom: "2px solid",
            borderColor: "divider",
            background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
            borderRadius: 3,
            p: 3,
          }}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", sm: "center" }}
            spacing={3}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 60,
                  height: 60,
                  backgroundColor: "#45ab49",
                  borderRadius: "50%",
                  boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
                }}
              >
                <LocationOn sx={{ fontSize: 28, color: "white" }} />
              </Box>
              <Box>
                <Typography
                  variant="h4"
                  component="h3"
                  sx={{
                    fontWeight: 700,
                    background:
                      "linear-gradient(135deg, #2c3e50 0%, #45ab49 100%)",
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                    mb: 0.5,
                  }}
                >
                  Address Book
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    fontWeight: 500,
                  }}
                >
                  Manage your delivery addresses
                </Typography>
              </Box>
            </Stack>
            <Button
              variant="contained"
              startIcon={<Add />}
              data-toggle="modal"
              data-target="#addaddress"
              sx={{
                borderRadius: 3,
                px: 4,
                py: 1.5,
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 700,
                background: "#45ab49",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                "&:hover": {
                  background: "#45ab49",
                  boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
                  transform: "translateY(-2px)",
                },
                transition: "all 0.3s ease-in-out",
              }}
            >
              Add New Address
            </Button>
          </Stack>
        </Box>

        {/* Loading State */}
        {loading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              py: 8,
            }}
          >
            <CircularProgress size={60} />
          </Box>
        )}

        {/* Address Table */}
        {!loading && show_address?.length === 0 ? (
          <Box
            sx={{
              textAlign: "center",
              py: 10,
              px: 3,
              backgroundColor: "white",
              borderRadius: 3,
              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              border: "2px dashed",
              borderColor: "divider",
            }}
          >
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 100,
                height: 100,
                backgroundColor: "#f8f9fa",
                borderRadius: "50%",
                mb: 3,
              }}
            >
              <LocationOn
                sx={{
                  fontSize: 48,
                  color: "primary.main",
                  opacity: 0.7,
                }}
              />
            </Box>
            <Typography
              variant="h5"
              gutterBottom
              sx={{
                fontWeight: 600,
                color: "text.primary",
                mb: 1,
              }}
            >
              No Addresses Found
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                mb: 4,
                maxWidth: 400,
                mx: "auto",
                lineHeight: 1.6,
              }}
            >
              You haven't added any addresses yet. Add your first address to
              make shopping easier and faster.
            </Typography>
            <Button
              variant="contained"
              startIcon={<Add />}
              data-toggle="modal"
              data-target="#addaddress"
              sx={{
                borderRadius: 3,
                px: 4,
                py: 1.5,
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 600,
                background: "#45ab49",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                "&:hover": {
                  background: "#45ab49",
                  boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
                  transform: "translateY(-2px)",
                },
                transition: "all 0.3s ease-in-out",
              }}
            >
              Add Your First Address
            </Button>
          </Box>
        ) : (
          !loading && (
            <Paper
              sx={{
                width: "100%",
                overflow: "hidden",
                borderRadius: 3,
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              }}
            >
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f8f9fa" }}>
                      <TableCell
                        sx={{
                          fontWeight: 700,
                          fontSize: "0.9rem",
                        }}
                      >
                        Type
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 700,
                          fontSize: "0.9rem",
                        }}
                      >
                        Location Name
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 700,
                          fontSize: "0.9rem",
                        }}
                      >
                        Address
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 700,
                          fontSize: "0.9rem",
                        }}
                      >
                        City
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 700,
                          fontSize: "0.9rem",
                        }}
                      >
                        Pincode
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 700,
                          fontSize: "0.9rem",
                        }}
                      >
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {show_address?.map((items, index) => (
                      <TableRow
                        key={items._id}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                          backgroundColor:
                            index === 0
                              ? "rgba(69, 171, 73, 0.05)"
                              : "transparent",
                          borderLeft:
                            index === 0 ? "4px solid #45ab49" : "none",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.02)",
                          },
                        }}
                      >
                        <TableCell>
                          <Chip
                            icon={<Home sx={{ fontSize: 16 }} />}
                            label={index === 0 ? "Primary" : "Additional"}
                            color={index === 0 ? "primary" : "default"}
                            variant={index === 0 ? "filled" : "outlined"}
                            size="small"
                            sx={{
                              fontWeight: 600,
                              fontSize: "0.75rem",
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <Typography variant="body1" sx={{ fontWeight: 600 }}>
                            {items.landmark}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ maxWidth: 300 }}>
                          <AddressText text={items.address} maxLength={50} />
                        </TableCell>
                        <TableCell>
                          <Typography variant="body1">{items.city}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body1">
                            {items.pin_code}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Stack direction="row" spacing={1}>
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<Edit sx={{ fontSize: 16 }} />}
                              data-toggle="modal"
                              data-target="#editaddress"
                              onClick={() =>
                                eidtaddreddss(
                                  items._id,
                                  items.landmark,
                                  items.address,
                                  items.city,
                                  items.pin_code
                                )
                              }
                              sx={{
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "0.8rem",
                                borderWidth: 1,
                              }}
                            >
                              Edit
                            </Button>
                            <Button
                              variant="outlined"
                              size="small"
                              color="error"
                              startIcon={
                                deleteLoading === items._id ? (
                                  <CircularProgress size={14} />
                                ) : (
                                  <Delete sx={{ fontSize: 16 }} />
                                )
                              }
                              onClick={() => deleteaddress(items._id)}
                              disabled={deleteLoading === items._id}
                              sx={{
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "0.8rem",
                                borderWidth: 1,
                              }}
                            >
                              {deleteLoading === items._id
                                ? "Deleting..."
                                : "Delete"}
                            </Button>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          )
        )}

        {/* Address Text Component with Read More/Less */}
        {!loading && (
          <Dialog
            open={addressDialog.open}
            onClose={() => setAddressDialog({ open: false, address: "" })}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle
              sx={{
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid #e0e0e0",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <LocationOn sx={{ color: "#45ab49" }} />
              Full Address Details
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
              <Typography
                variant="body1"
                sx={{ lineHeight: 1.8, whiteSpace: "pre-wrap" }}
              >
                {addressDialog.address}
              </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button
                onClick={() => setAddressDialog({ open: false, address: "" })}
                variant="contained"
                sx={{ borderRadius: 2 }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* Add Address Modal */}
        <div className="modal fade" id="addaddress" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New Address</h5>
                <button type="button" className="close" data-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={FormHandel}>
                  <div className="form-group">
                    <label>Landmark</label>
                    <input
                      type="text"
                      className="form-control"
                      name="landmark"
                      value={add_address.landmark}
                      onChange={inpuHandel}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Address</label>
                    <textarea
                      className="form-control"
                      name="address"
                      value={add_address.address}
                      onChange={inpuHandel}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>City</label>
                    <input
                      type="text"
                      className="form-control"
                      name="city"
                      value={add_address.city}
                      onChange={inpuHandel}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Pincode</label>
                    <input
                      type="text"
                      className="form-control"
                      name="pin_code"
                      value={add_address.pin_code}
                      onChange={inpuHandel}
                      maxLength={6}
                      required
                    />
                    {pincodemsg && (
                      <div className="text-danger small mt-1">{pincodemsg}</div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={addLoading}
                    >
                      {addLoading ? (
                        <>
                          <CircularProgress size={16} className="mr-2" />
                          Adding...
                        </>
                      ) : (
                        "Add Address"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Address Modal */}
        <div
          className="modal fade"
          id="editaddress"
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Address</h5>
                <button type="button" className="close" data-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={editFormHandel}>
                  <div className="form-group">
                    <label>Landmark</label>
                    <input
                      type="text"
                      className="form-control"
                      name="landmark"
                      value={editaddress.landmark}
                      onChange={editinpuHandel}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Address</label>
                    <textarea
                      className="form-control"
                      name="address"
                      value={editaddress.address}
                      onChange={editinpuHandel}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>City</label>
                    <input
                      type="text"
                      className="form-control"
                      name="city"
                      value={editaddress.city}
                      onChange={editinpuHandel}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Pincode</label>
                    <input
                      type="text"
                      className="form-control"
                      name="pin_code"
                      value={editaddress.pin_code}
                      onChange={editinpuHandel}
                      maxLength={6}
                      required
                    />
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={editLoading}
                    >
                      {editLoading ? (
                        <>
                          <CircularProgress size={16} className="mr-2" />
                          Updating...
                        </>
                      ) : (
                        "Update Address"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Box>

      {/* Modal */}
      <div
        className="modal fade"
        id="editaddress"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit Address
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form method="post">
                <div className="modal-body">
                  <div className="form-group">
                    <label>Location</label>
                    <input
                      type="nme"
                      className="form-control"
                      defaultValue={editaddress.landmark}
                      name="landmark"
                      onChange={editinpuHandel}
                    />
                  </div>
                  <div className="form-group">
                    <label>Address</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editaddress.address}
                      name="address"
                      onChange={editinpuHandel}
                    />
                  </div>
                  <div className="form-group">
                    <label>City</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editaddress.city}
                      name="city"
                      onChange={editinpuHandel}
                    />
                  </div>
                  <div className="form-group">
                    <label>Pincode</label>
                    <input
                      type="number"
                      maxLength="6"
                      className="form-control"
                      defaultValue={editaddress.pin_code}
                      name="pin_code"
                      onChange={editinpuHandel}
                    />
                    <label style={{ color: "red", fontSize: "10px" }}>
                      {pincodemsg}
                    </label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={editFormHandel}
                  >
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Modal */}
      <div
        className="modal fade"
        id="addaddress"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Address
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form method="post">
                <div className="modal-body">
                  <div className="form-group">
                    <label>Location</label>
                    <input
                      type="nme"
                      className="form-control"
                      required
                      name="landmark"
                      onChange={inpuHandel}
                    />
                  </div>
                  <div className="form-group">
                    <label>Address</label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      name="address"
                      onChange={inpuHandel}
                    />
                  </div>
                  <div className="form-group">
                    <label>City</label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      name="city"
                      onChange={inpuHandel}
                    />
                  </div>
                  <div className="form-group">
                    <label>Pincode</label>
                    <input
                      type="number"
                      maxLength="6"
                      className="form-control"
                      required
                      name="pin_code"
                      onChange={inpuHandel}
                    />
                    <label style={{ color: "red", fontSize: "10px" }}>
                      {pincodemsg}
                    </label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={FormHandel}
                  >
                    ADD
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Address;
